"use strict";

var CommonUtils = require('../../../server/lib/common.utils');
module.exports = /*@ngInject*/function () {
  return CommonUtils.camelcase;
};